import { render, staticRenderFns } from "./MarkInput.vue?vue&type=template&id=31e4bf32&scoped=true&"
import script from "./MarkInput.vue?vue&type=script&lang=js&"
export * from "./MarkInput.vue?vue&type=script&lang=js&"
import style0 from "./MarkInput.vue?vue&type=style&index=0&lang=less&"
import style1 from "./MarkInput.vue?vue&type=style&index=1&id=31e4bf32&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e4bf32",
  null
  
)

export default component.exports